import ROUTE from "@app/navigationApp/routes"
import Button from "@app/sharedComponents/Button/Button"
import { themeColorSet, ThemedText, ThemedView } from "@app/theme"
import LottieView from "lottie-react-native";
import lottie from "../../../assets/lottie/enhance-limit-success.json"
import fetchUserDetails from "@app/helper/fetchUserInfo";
import { Clock,WarningCircle } from '@app/sharedComponents/Icons/Icons';
import { useState } from "react";

const UpdateSuccess = ({navigation,route}) =>{
    const {type,response} = route?.params
    const [buttonLoader, setButtonLoader] = useState(false);
    const goToHome = () =>{
        setButtonLoader(true)
        fetchUserDetails()
        navigation.navigate(ROUTE.HOME)
        setButtonLoader(false)
    }

    const retry = ()=>{
        setButtonLoader(true)
        fetchUserDetails()
        navigation.navigate(ROUTE.DASHBOARD_SCREEN)
        setButtonLoader(false)
    }

    const isFailure = response?.status === "FAILURE" || response?.status === "REJECTED"
    const isInProgress = response?.status === "REQUESTED"
    const isSuccess = response?.status === "SUCCESS"
    const isFailureComponent =(
        <>
            <WarningCircle size={96} weight="fill" color={themeColorSet["icon-error"]} />
            <ThemedText variant="h3s" color="text-primary" mt="4xl" mb="sm" >Request failed</ThemedText>
            <ThemedText variant="b3r" color="text-secondary">There was an error updating your details. Please try again</ThemedText>
        </>
    )
    
    const isInProgressComponent =(
        <>
            <ThemedView width={96} height={96} borderRadius="full" backgroundColor="bg-fill-warning" justifyContent="center" alignItems="center" mb="4xl">
            <Clock size={48} weight="fill" color={themeColorSet["icon-warning"]} /> 
            </ThemedView>
            <ThemedText variant="h3s" color="text-primary" mb="sm" >{type === 'PHONE_NUMBER'?"Mobile number update requested":"Email ID update requested"} </ThemedText>
            <ThemedText variant="b3r" color="text-secondary"  mb="lg">The request will be processed in 1-3 business days.</ThemedText>
            {type === 'PHONE_NUMBER'&&
            <ThemedView backgroundColor="bg-fill-secondary" borderRadius="md" p="md">
                <ThemedText variant="b3r" color="text-secondary">Use the new mobile number to login to your account.</ThemedText>
            </ThemedView>
            }
        </>
    )

    const isSuccessComponent =(
        <>
            <LottieView
                source={lottie}
                style={{ width: 100, height: 100 }}
                autoPlay={true}
                loop={true}
            />
            <ThemedText mt="4xl" variant="h3s" color="text-primary" mb="lg" textAlign="center" >{type !== 'PHONE_NUMBER'?"Mobile number updated successfully":"Email ID updated successfully"} </ThemedText>
            {type === 'PHONE_NUMBER'&&
            <ThemedView backgroundColor="bg-fill-secondary" borderRadius="md" p="md" >
                <ThemedText variant="b3r" color="text-secondary">Use the new mobile number to login to your account.</ThemedText>
            </ThemedView>
            }
        </>
    )

    return(
        <>
        <ThemedView backgroundColor="bg-surface-primary" flex={1} p="lg" justifyContent="center" alignItems="center">
            {isFailure && isFailureComponent}
            {isSuccess && isSuccessComponent}
            {isInProgress && isInProgressComponent}
        </ThemedView>
        <ThemedView backgroundColor="bg-surface-primary" p="lg">
            {isFailure?
            <Button buttonLoader={buttonLoader} type="SOLID" size="MD" label="Retry" handlePress={retry} />
            :
            <Button buttonLoader={buttonLoader} type="SOLID" size="MD" label="Ok, got it!" handlePress={goToHome} />
            }
        </ThemedView>
        </>
    )
}

export default UpdateSuccess